module.exports = __webpack_public_path__ + "img/reuserate.4f57f38d.png";